'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../tslib.es6-fe93d37b.js');
require('react');
require('../device.consts-2b011893.js');
var useWindowDimensions_hook = require('../useWindowDimensions.hook-e1e5a62f.js');



exports.useIsSmallViewportWidth = useWindowDimensions_hook.useIsSmallViewportWidth;
exports.useWindowDimensions = useWindowDimensions_hook.useWindowDimensions;
